import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { TeamsStore } from 'pages/settings/pages/teams/store/TeamsStore'
import styles from './styles.module.scss'

export type IRenameTeamModalActionsProps = {
  store: TeamsStore
}

export const RenameTeamModalActions = observer(({ store }: IRenameTeamModalActionsProps) => (
  <div className={styles.actionsContainer}>
    <Button
      text='Cancel'
      size='medium'
      contained='secondary'
      onClick={store.closeRenameTeamModal}
    />
    <Button
      text='Save'
      size='medium'
      disabled={!store.renameTeamCanSave}
      loading={store.renameTeamLoading}
      onClick={store.handleRenameTeamSave}
    />
  </div>
))
